export default function ComplianceSection() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-white border border-background-200/70 rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-start gap-5 animate-on-scroll">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 flex-shrink-0">
            <i className="ri-file-shield-2-line text-xl"></i>
          </div>
          <div>
            <h2 className="text-base md:text-lg font-bold font-heading text-foreground-950 mb-2">
              Rapport de conformité &amp; responsabilité
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Cotations{' '}
              <strong className="text-foreground-800 font-semibold">indicatives</strong>, sans valeur
              d&apos;avis médical ou juridique. La facturation reste sous la responsabilité exclusive
              de l&apos;infirmier libéral. CotIdel n&apos;endosse pas les indus réclamés par
              l&apos;Assurance Maladie.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}